// extracted by mini-css-extract-plugin
export var base = "_3w-0";
export var updateBanner = "_3w-1";